import type { Theme } from '@emotion/react'
import { css, keyframes } from '@emotion/react'

import {
  borderRadius,
  breakpoint,
  duration,
  fontSize,
  size,
} from '@twisto/styles'

const mobilePinWidth = 20
const desktopPinWidth = 24

export const pin = (theme: Theme) => css`
  max-width: ${mobilePinWidth}px;
  margin: 0 ${mobilePinWidth / 2}px 0;
  padding: 6px;
  font-size: ${fontSize.xxl};
  line-height: ${fontSize.xxl};
  font-weight: 700;
  transition: transform ${duration.short}ms;
  transform: scale(0.8);
  position: relative;
  border-radius: ${borderRadius.circle};
  background: ${theme.palette.neutral[200]};

  ${breakpoint.up('sm')} {
    max-width: ${desktopPinWidth}px;
    margin: 0 ${desktopPinWidth / 2}px 0;
    padding: ${size[8]};
  }

  &:after,
  &:before {
    display: block;
    height: 8px;
    width: 8px;
    content: '';
    border-radius: ${borderRadius.circle};
  }
  &:after {
    background: ${theme.palette.neutral[300]};
  }
  &:before {
    opacity: 0;
    position: absolute;
    background: ${theme.palette.neutral[600]};
  }
  label:focus-within &,
  label:hover & {
    transform: scale(1);
  }
`

export const filledClass = (theme: Theme) => css`
  background: ${theme.palette.brand[100]};

  &:after {
    background: ${theme.palette.brand[500]};
  }
`

export const charPinClass = (theme: Theme) => css`
  background: none;
  border-radius: 0;
  height: auto;
  transition: color ${duration.short}ms;
  transform: scale(1);
  color: ${theme.palette.neutral[900]};

  &:after {
    content: none;
  }
  label:focus-within &,
  label:hover & {
    color: ${theme.palette.neutral[900]};
  }
`

export const readOnlyClass = (theme: Theme) => css`
  color: ${theme.palette.neutral[900]};
`
const blinkAnimation = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
`

export const currentClass = (theme: Theme) => css`
  background: ${theme.palette.neutral[200]};

  label:focus-within &:before {
    animation: ${blinkAnimation} 950ms infinite ease;
  }
  label:focus-within &,
  label:hover & {
    box-shadow: 0 0 0 2px ${theme.palette.neutral[600]};
  }
`
